import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, Optional, Output } from "@angular/core";
import { ClientFormsService } from "../client-forms.service";
import { AuthService, PredefinedUserZone } from "@saliente/common-auth";
import { RestService } from "@saliente/common";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { DeclaratiaUnicaPfaModel, DuActivitatiIndependenteModel, DuChiriiModel, DuPfa2024Model, FormStatus, SistemImpozitareActivitatiIndependente, SistemImpozitareChirii } from "../client-forms.models";
import { EXPERT_ROUTES } from "@saliente/expert";
import { switchMap } from "rxjs/operators";
import { CLIENT_FORMS_ROUTES } from "../client-forms.routes.constants";

@Component({
    selector: 'dupfa2024-form',
    templateUrl: 'dupfa2024-form.component.html',
    styleUrls: ['dupfa2024-form.component.scss'],
    standalone: false
})
export class DuPFA2024FormComponent {
	@Input() public isDialog: boolean;
    @Input() public clientEidParam: string;
    @Input() public instanceParam: string;

	@Output() public close = new EventEmitter();
    
    //subscriptions
	private duPfaDataSubscription: Subscription;
	private selectedCompanyIdSubscription: Subscription;
    
    //models
    public model: DuPfa2024Model;

    public clientEid: string;
    public instance: string;

	//booleans
	public isReadOnly: boolean;
	public hasViewRight: boolean;
	public isLoading: boolean;
	public isExpert: boolean;
	public isClient: boolean;

	constructor(private clientFormsService: ClientFormsService, private authService: AuthService, private restService: RestService, private route: ActivatedRoute,
		private toastr: ToastrService, private cdr: ChangeDetectorRef, private router: Router,
		@Optional() @Inject('instance') public instanceRouteParam: string) {}
 
	ngOnInit(): void {
		let currentCompanyId = this.authService.user.selectedCompanyId;
		this.selectedCompanyIdSubscription = this.authService
			.getSelectedCompanyId()
			.subscribe((companyId) => {
				if (currentCompanyId != companyId && this.isExpert) {
					this.router.navigate([EXPERT_ROUTES.ROOT, EXPERT_ROUTES.DASHBOARD]);
				}
			});

		this.getDuPfaKeez2024Data();
		this.isExpert = this.authService.selectedZoneCode == PredefinedUserZone.Expert && this.authService.isInRole('EXPERT');
		this.isClient = this.authService.selectedZoneCode == PredefinedUserZone.Administrator;
	}
	
	ngOnDestroy(): void {
		if (this.duPfaDataSubscription) { this.duPfaDataSubscription.unsubscribe(); this.duPfaDataSubscription = null; }
		if (this.selectedCompanyIdSubscription) { this.selectedCompanyIdSubscription.unsubscribe(); this.selectedCompanyIdSubscription = null; }
	}

	public getDuPfaKeez2024Data() {
        this.isLoading = true;
        this.duPfaDataSubscription = this.route.paramMap
            .pipe(
                switchMap((params: ParamMap) => {
                    this.clientEid = this.isDialog ? this.clientEidParam : params.get('id');
                    this.instance = this.isDialog ? this.instanceParam : this.instanceRouteParam;
                    return this.clientFormsService.getDuPfaKeez2024Data(this.clientEid);
                })
		    )
			.subscribe((duPFAFormModel: DuPfa2024Model) => {
                if (duPFAFormModel) {
                    this.isReadOnly = duPFAFormModel.formData.status == FormStatus.Submitted;
                    
                    let roles = this.splitRoles(duPFAFormModel.formData.displayRole);
                    this.hasViewRight = this.authService.isInRole('EXPERT') || this.authService.isInRole('ZEUS') 
                        || roles.some((r) => this.authService.isInRole(r));

                    if (this.hasViewRight) {
                        this.model = duPFAFormModel;

                        if (this.model.formData.status != FormStatus.Submitted) {
                            //this.computeBooleans();
                        }
                    }
                }
                else {
                    this.model = null;
                }

                this.isLoading = false;

                setTimeout(() => {
                    this.cdr.detectChanges();
                }, 200);
		});
    }

	public splitRoles(displayRole: string) {
        let roles: string[] = displayRole.split('|');
        return roles;
    }

    public async updateDuPfaForm(duPfaData: any) {
        if (duPfaData.doSubmit) {
            this.submitForm(duPfaData)
        }
        else {
           this.saveForm();
        }
    }

    public async saveForm() {
        let result = await this.clientFormsService.updateClientFormDuPfaKeez2024Data(this.clientEid, false, this.model.data);
        if (result) {
            if (this.isDialog) {
                this.close.emit();
            }
            this.toastr.success("Formularul a fost salvat");
        }
    }

    public async submitForm(duPfaData: any) {
        if (this.isClient) { // no validations needed
            let result = await this.clientFormsService.updateClientFormDuPfaKeez2024Data(this.clientEid, true, this.model.data);
            if (result) {
                if (this.isDialog) {
                    this.close.emit();
                }
                else {
                    this.getDuPfaKeez2024Data();
                }
                
                this.toastr.success("Formularul a fost trimis");
            }
        }
        else if (this.isExpert) {
            if (duPfaData.duPfaForm.form.valid) {
                if (this.isFormValid()) {

                    //warning
                    if (this.model.data.persoana.areHandicap || this.model.data.persoana.nerezident) {
                        let warningMsg = "Atenție!";
                        warningMsg += this.model.data.persoana.areHandicap ? " Are handicap." : "";
                        warningMsg += this.model.data.persoana.nerezident ? " Este nerezisent." : "";

                        this.toastr.warning(warningMsg);
                    }

                    let result = await this.clientFormsService.updateClientFormDuPfaKeez2024Data(this.clientEid, true, this.model.data);
                    if (result) {
                        if (this.isDialog) {
                            this.close.emit();
                        }
                        else {
                            this.getDuPfaKeez2024Data();
                        }
                        
                        this.toastr.success("Formularul a fost trimis");
                    }
                }
            }
            else {
                this.toastr.error("Există erori de validare în formular!");
                this.clientFormsService.isFormTouched.next();
                duPfaData.duPfaForm.form.markAllAsTouched();
            }
        }
    }

    public isFormValid() {
        //type: 0 - realizat, 1 - estimat
		let errorMessages: string[] = [];

        if (this.model.data.chiriiRealizat != undefined && this.model.data.chiriiRealizat.length > 0) {
            this.model.data.chiriiRealizat.forEach((chirie, index) => {
                let messages = this.validateChirie(chirie, index);
                if (messages.length > 0) {
                    messages.forEach((msg) => {
                        errorMessages.push(msg);
                    });
                }
            })
        }

        if (this.model.data.activitatiIndependenteRealizat != undefined && this.model.data.activitatiIndependenteRealizat.length > 0) {
            this.model.data.activitatiIndependenteRealizat.forEach((activitate, index) => {
                let messages = this.validateActivitateIndependenta(activitate, index);
                if (messages.length > 0) {
                    messages.forEach((msg) => {
                        errorMessages.push(msg);
                    });
                }
            })
        }

        if (errorMessages.length > 0) {
            this.restService.displayErrors(errorMessages);
            return false;
        }

		return true;
    }

    public validateChirie(chirie: DuChiriiModel, indexChirie: number): string[] {
		let errorMessages: string[] = [];

        let isSistemReal = chirie.sistemImpozitare != undefined && chirie.sistemImpozitare == SistemImpozitareChirii.SistemReal;

        if (chirie.sistemImpozitare == undefined || chirie.sistemImpozitare == '' || 
            chirie.adresa == undefined || chirie.adresa == '' || 
            chirie.numarDocument == undefined ||
            chirie.dataDocument == undefined ||
            chirie.venitBrut == undefined ||
            (isSistemReal && chirie.cheltuieliDeductibile == undefined)) {
                errorMessages.push(`Nu ați completat câmpurile obligatorii: CHIRIA ${(indexChirie + 1).toString()}`);
                return errorMessages;
            }

        if (this.validateDate(chirie.dataInceperiiActivitatiiEx)) {
            errorMessages.push(`Data începerii activității trebuie să fie în interiorul anului de referință (${this.model.formDataParameters.anRealizat.toString()}): CHIRIA ${(indexChirie + 1).toString()}`);
        }

        if (this.validateDate(chirie.dataIncetariiActivitatiiEx)) {
            errorMessages.push(`Data încetării activității trebuie să fie în interiorul anului de referință (${this.model.formDataParameters.anRealizat.toString()}): CHIRIA ${(indexChirie + 1).toString()}`);
        }

        return errorMessages;
    }

    public validateActivitateIndependenta(activitate: DuActivitatiIndependenteModel, indexActivitate: number): string[] {
		let errorMessages: string[] = [];

        let isSistemReal = activitate.sistemImpozitare != undefined && activitate.sistemImpozitare == SistemImpozitareActivitatiIndependente.SistemReal;
        let isNormaDeVenit = activitate.sistemImpozitare != undefined && activitate.sistemImpozitare == SistemImpozitareActivitatiIndependente.NormaDeVenit;

        if (activitate.sistemImpozitare == undefined || activitate.sistemImpozitare == '' ||
            activitate.codCaen == undefined || activitate.codCaen == '' ||
            activitate.sediuSauIdentificareBun == undefined || activitate.sediuSauIdentificareBun == '' ||
            activitate.numarDocument == undefined || 
            activitate.dataDocument == undefined ||
            (isSistemReal && activitate.venitBrut == undefined) ||
            (isSistemReal && activitate.cheltuieliDeductibile == undefined) ||
            (isNormaDeVenit && activitate.normaDeVenit == undefined)) {
                errorMessages.push(`Nu ați completat câmpurile obligatorii: ACTIVITATEA ${(indexActivitate + 1).toString()}`);
                return errorMessages;
            }

        if (this.validateDate(activitate.dataInceperiiActivitatiiEx)) {
            errorMessages.push(`Data începerii activității trebuie să fie în interiorul anului de referință (${this.model.formDataParameters.anRealizat.toString()}): ACTIVITATEA ${(indexActivitate + 1).toString()}`);
        }

        if (this.validateDate(activitate.dataIncheieriiActivitatiiEx)) {
            errorMessages.push(`Data încetării activității trebuie să fie în interiorul anului de referință (${this.model.formDataParameters.anRealizat.toString()}): ACTIVITATEA ${(indexActivitate + 1).toString()}`);
        }

        return errorMessages;
    }

    public validateDate(date: Date) {
        return date != undefined && (date < this.getMinDate() || date > this.getMaxDate());
    }

    public getMinDate(): Date {
        return new Date(this.model.formDataParameters.anRealizat, 0, 1);
    }

    public getMaxDate(): Date {
        return new Date(this.model.formDataParameters.anRealizat, 11, 31);
    }

    public async invalidateForm() {
        let result = await this.clientFormsService.invalidateClientForm(this.clientEid, CLIENT_FORMS_ROUTES.DU_PFA_FORM, this.instance);
        if (result) {
            this.getDuPfaKeez2024Data();
            this.toastr.success("Formularul a fost deblocat cu succes!");
        }
    }

    public downloadForm() {
        this.clientFormsService.generateDuPfaKeez(this.clientEid, this.instance);
    }
}
